import React, { memo, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { createSelector } from 'reselect';
import KeepAlive, { useActivate, useUnactivate } from 'react-activation';
import { logging, logPostInfo } from '../../actions/log';
import { getRecoBanner, getRecoRecommend } from '../../actions/recommend';
import CardIndex from '../../card/CardIndex/CardIndex';
import styles from './RecoWork.module.less';
import Loading from '../../components/Loading/Loading';

const selectRecoBanner = createSelector(
  state => state.recommend,
  recommend => recommend.recoWorkBanner,
);
const selectRecoRecommend = createSelector(
  state => state.recommend,
  recommend => recommend.recoWorkRecommend,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

function Work() {
  // export default memo(() => {
  const dispatch = useDispatch();
  const location = useLocation();

  const recoBanner = useSelector(selectRecoBanner);
  const recoRecommend = useSelector(selectRecoRecommend);
  const logInfoData = useSelector(selectLogInfo);

  const [getBannerKey, setGetBannerKey] = useState(null);
  const [tagSource, setTagSource] = useState('work');

  const [initTime, setInitTime] = useState(+new Date());

  // 浏览时长打桩
  const leaveTimeLog = useCallback(() => {
    const leaveTime = +new Date();
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: tagSource || `Work`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime,
          leaveTime,
          time: leaveTime - initTime,
        },
      }),
    );
  }, [tagSource, initTime]);

  const pagePvLog = useCallback(() => {
    dispatch(
      logging({
        category: 'P',
        action: 'Work',
        label: '',
        param2: {
          source: 'Work',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'Work',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
      }),
    );
  });

  useActivate(() => {
    setInitTime(+new Date());
  });
  useUnactivate(() => {
    leaveTimeLog();
  });

  useEffect(() => {
    pagePvLog();
  }, []);
  useActivate(() => {
    pagePvLog();
  });

  // 展示发生变化打桩
  const changView = content => {
    dispatch(
      logging({
        category: 'I',
        action: 'Work_Content_Show',
        label: '',
        param2: {
          source: 'Work',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          ...content,
        },
      }),
    );
  };

  /**
   * 获取banner数据，每次进来都获取
   * 因为广告接入，计算统计接口请求，和展示次数矛盾。
   * 所以改为：每次展示banner，都重新请求一次数据
   */
  useEffect(() => {
    const getBannerKeyNum = +new Date();
    setGetBannerKey(getBannerKeyNum);
    dispatch(getRecoBanner({ getBannerKey: getBannerKeyNum, pageType: 'work' }));
  }, [dispatch]);

  /**
   * 获取card list 数据
   */
  useEffect(() => {
    if (
      location &&
      location.pathname.indexOf('/work') > -1 &&
      (!recoRecommend ||
        !recoRecommend.data ||
        !recoRecommend.data.length ||
        recoRecommend.pageType !== 'work')
    ) {
      dispatch(getRecoRecommend({ pageType: 'work' }));
    }
  }, [dispatch, location, recoRecommend]);

  if (
    !(
      recoBanner &&
      recoBanner.pageType === 'work' &&
      recoBanner.getBannerKey === getBannerKey &&
      recoBanner.data &&
      recoBanner.data.length > 0 &&
      recoRecommend &&
      recoRecommend.pageType === 'work' &&
      recoRecommend.data.length > 0
    )
  ) {
    return (
      <div className={styles.loading}>
        <Loading />
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <div className={styles.page_container}>
        {tagSource &&
          recoBanner &&
          recoBanner.pageType === 'work' &&
          recoBanner.getBannerKey === getBannerKey &&
          recoBanner.data &&
          recoBanner.data.length > 0 &&
          recoRecommend &&
          recoRecommend.pageType === 'work' &&
          recoRecommend.data.length > 0 && (
            <React.Fragment>
              <div className={styles.reco_banner}>
                {recoBanner.data.map((item, i) => (
                  <CardIndex data={{ ...item }} key={i} logInfo={{ tag: tagSource, changView }} />
                ))}
              </div>
              {recoRecommend.data.map((item, i) => (
                <CardIndex data={{ ...item }} key={i} logInfo={{ tag: tagSource, changView }} />
              ))}
            </React.Fragment>
          )}
      </div>
    </div>
  );
}
// });

export default () => (
  <KeepAlive name="work">
    <Work></Work>
  </KeepAlive>
);
